<template>
  <div class="container">
    <div class="nav-container">
      <div class="header">
        <img class="back" src="@/images/back.png" @click="goBack" />
        支付明细
        <!-- <a class="login" @click="showPop">筛选</a> -->
      </div>
    </div>
    <div class="top-margin"></div>
    <div class="">
      <!-- <div class="display_column"> -->
        <!-- <span class="t-f14-c1a">近一年</span> -->
        <!-- <span class="t-f12-c66">累计</span> -->
      <!-- </div> -->
      <div class="right-lable-container">
        <!-- <div class="display_column column-center">
          <span class="t-f12-c66">订单</span>
          <span class="t-f12-c66">{{ list.length }}</span>
        </div> -->
        <!-- <div class="line" />
        <div class="display_column column-center">
          <span class="t-f12-c66">消费(-)</span>
          <span class="t-f12-c66">--</span>
        </div>
        <div class="line" />
        <div class="display_column column-center">
          <span class="t-f12-c66">充值(+)</span>
          <span class="t-f12-c66">--</span>
        </div> -->
      </div>
    </div>
    <div v-if="list.length > 0">
      <div class="list-item" v-for="item in list" :key="item">
        <div class="display_column">
          <span class="t-f14-c1a">{{ item.payType }}</span>
          <span class="t-f12-c66">{{
            $filters.timeFormate(item.updated_at)
          }}</span>
        </div>
        <span class="price t-f16-c1a font-bold"
          >{{ item.unit }}{{ item.amount }}</span
        >
      </div>
    </div>
    <van-empty description="暂无数据" v-else></van-empty>
  </div>

  <!-- 挂载到 body 节点下 -->
  <van-popup
    v-model:show="showFilter"
    position="right"
    teleport="body"
    :style="{ height: '100%', width: '90%' }"
  >
    <div class="pop-container">
      <div class="display_flex">
        <span class="t-f14-c1a">查询类型</span>
        <span class="t-f14-c99">(支持多选)</span>
      </div>
      <van-grid
        :column-num="3"
        :gutter="10"
        :border="false"
        style="margin-top: 15px"
      >
        <van-grid-item v-for="(item, index) in filterCheckType" :key="item">
          <div
            class="grid-item"
            :class="item.isSelected && 'selected'"
            @click="selectCheckCondition(index)"
          >
            {{ item.text }}
          </div>
        </van-grid-item>
      </van-grid>
      <div class="display_flex m-t-20">
        <span class="t-f14-c1a">时间跨度</span>
      </div>
      <van-grid
        :column-num="3"
        :gutter="10"
        :border="false"
        style="margin-top: 15px"
      >
        <van-grid-item v-for="(item, index) in filterSearch" :key="item">
          <div
            class="grid-item"
            :class="item.isSelected && 'selected'"
            @click="selectSearchBtn(index)"
          >
            {{ item.text }}
          </div>
        </van-grid-item>
      </van-grid>
      <div v-if="showDataView" class="m-t-20">
        <div class="display_flex">
          <span class="t-f14-c1a">日期查询</span>
        </div>
        <div class="display_flex m-t-20">
          <span class="grid-item" @click="showPickerView(0)">{{
            $filters.yearMonthDateFormate(oldTime)
          }}</span>
          <div class="filter-line" />
          <span class="grid-item" @click="showPickerView(1)">{{
            $filters.yearMonthDateFormate(futureTime)
          }}</span>
        </div>
      </div>
    </div>
  </van-popup>
  <van-popup
    v-model:show="showPicker"
    position="bottom"
    teleport="body"
    :style="{ height: '50%', width: '100%' }"
  >
    <van-datetime-picker
      v-model="pickerDefultDate"
      type="date"
      @confirm="pickerConfirm"
      @cancel="pickerCancle"
      title="选择年月日"
      :min-date="minDate"
      :max-date="maxDate"
    />
  </van-popup>
</template>

<script>
import { useRouter } from "vue-router";
import { ref } from "vue";
import request from "@/api/request";

let router;
let showFilter;
let currentSelectPickerView;
let filterCheckType;
let filterSearch;
let currentTime;
//timePicker defult  date
let pickerDefultDate;
let minDate;
let maxDate;

let showDataView;
let showPicker;

//date
let oldTime;
let futureTime;

let list = ref([]);
export default {
  components: {},
  setup() {
    router = useRouter();
    intActiviyDefultData();
    return {
      goBack,
      showFilter,
      pickerDefultDate,
      minDate,
      maxDate,
      oldTime,
      futureTime,
      showPop,
      list,
      filterCheckType,
      filterSearch,
      showPicker,
      showDataView,
    };
  },
  created() {
    this.initApi();
  },

  methods: {
    initApi() {
      let filterData = {};
      filterData["page"] = 1;
      filterData["per_page"] = 100;
      request.getUserPayment(filterData).then((res) => {
        const data = res.data.results;
        list.value = this.formateType(data);
      });
    },
    formateType(array) {
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        if (element.transaction_type == "consumption") {
          element.payType = "充电";
          element.unit = "-";
        }
        if (element.transaction_type == "recharge") {
          element.payType = "充值";
          element.unit = "+";
        }
        if (element.transaction_type == "withdraw") {
          element.payType = "提现";
          element.unit = "-";
        }
        if (element.transaction_type == "refund") {
          element.payType = "退款";
          element.unit = "+";
        }
      }
      return array;
    },
    pickerConfirm(value) {
      if (currentSelectPickerView.value == 0) {
        oldTime.value = value;
      }
      if (currentSelectPickerView.value == 1) {
        futureTime.value = value;
      }
      showPicker.value = false;
    },
    showPickerView(index) {
      //assign  selected date
      if (index == 0) {
        //assign pickerContainer  defult date
        pickerDefultDate.value = oldTime.value;
      }
      if (index == 1) {
        pickerDefultDate.value = futureTime.value;
      }
      showPicker.value = true;
      //record  user  current click
      currentSelectPickerView.value = index;
    },
    pickerCancle() {
      showPicker.value = false;
    },
    selectCheckCondition(index) {
      //if  check all
      if (index === 0) {
        this.containerCheckAll(filterCheckType.value, index);
      }
      //children view  update   check  model
      if (index !== 0) {
        this.itemCheckUpdate(filterCheckType.value, index);
      }
    },
    containerCheckAll(list, index) {
      list[index].isSelected = !list[index].isSelected;
      for (let i = 0; i < list.length; i++) {
        //if  check is allBtn
        list[i].isSelected = list[index].isSelected;
      }
    },
    checkLinkage(list) {
      let j = 0;
      for (let index = 0; index < list.length; index++) {
        j = list[index].isSelected ? j + 1 : 0;
      }
      list[0].isSelected = j == list.length - 1;
    },
    itemCheckUpdate(list, index) {
      list[index].isSelected = !list[index].isSelected;
      // allBtn relation linkage
      this.checkLinkage(list);
    },
    setDateListDefult(list) {
      for (let i = 0; i < list.length; i++) {
        list[i].isSelected = false;
      }
    },
    selectSearchBtn(index) {
      let list = filterSearch.value;
      this.setDateListDefult(list);
      list[index].isSelected = !list[index].isSelected;
      //if btn is custom
      showDataView.value = (index == 2) === list[index].isSelected;
    },
  },
};
function intActiviyDefultData() {
  showFilter = ref(false);
  currentSelectPickerView = ref(0);
  filterCheckType = ref([
    { text: "全部", isSelected: true, code: "0" },
    { text: "充值", isSelected: false, code: "1" },
    { text: "消费", isSelected: false, code: "2" },
    { text: "退款", isSelected: false, code: "3" },
    { text: "集团", isSelected: false, code: "4" },
    { text: "个人", isSelected: false, code: "5" },
  ]);
  filterSearch = ref([
    { text: "近1月", isSelected: false, code: "0" },
    { text: "近6月", isSelected: false, code: "1" },
    { text: "自定义", isSelected: false, code: "2" },
  ]);
  currentTime = new Date();
  //timePicker defult  date
  pickerDefultDate = ref(currentTime);
  minDate = ref(new Date(currentTime.getFullYear() - 1, 0, 1));
  maxDate = ref(currentTime);
  showDataView = ref(false);
  showPicker = ref(false);

  //date
  oldTime = ref(
    new Date(
      currentTime.getFullYear() - 1,
      currentTime.getMonth(),
      currentTime.getDate()
    )
  );
  futureTime = ref(currentTime);
}
function goBack() {
  router.back();
}
function showPop() {
  showFilter.value = true;
}
</script>

<style lang="scss" scoped>
.filter-line {
  width: 10px;
  height: 2px;
  background: #d8d8d8;
  margin: auto 10px;
}
.selected {
  border: 1px solid #0082ff !important;
  background: rgba(0, 130, 255, 0.08) !important;
  color: #0082ff !important;
}
.grid-item {
  background: #f7f8f8;
  border-radius: 5px;
  border: 1px solid #f7f8f8;
  text-align: center;
  width: 100%;
  height: 100%;
  height: 40px;
  font-size: 13px;
  color: #1a1a1a;
  line-height: 40px;
}
.pop-container {
  padding: 20px;
}
.line {
  height: 10px;
  width: 1px;
  background: #dfdfdf;
  margin: 0px 20px;
}
.column-center {
  text-align: center;
}
.price {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
}
.list-item {
  border-bottom: 1px solid #eeeeee;
  padding: 12px 20px;
  position: relative;
}
.container {
  background: #fff;
  height: 100%;
}
.top-lable {
  background: #f1f2f3;
  position: relative;
  padding: 10px 20px;
}
// .right-lable-container {
//   position: absolute;
//   top: 50%;
//   align-items: center;
//   transform: translateY(-50%);
//   right: 20px;
//   display: flex;
// }
.nav-container {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 999;
}
.header {
  height: 45px;
  background: #fff;
  border-bottom: 1px solid #eee;
  font-size: 18px;
  color: #333;
  z-index: 999;
  text-align: center;
  line-height: 45px;
  position: relative;
}
.login {
  position: absolute;
  right: 20px;
  top: 2px;
  font-size: 14px;
  color: #005aa0;
}
.back {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  height: 20px;
}
::v-deep.van-grid {
  padding: 0px !important;
}
::v-deep.van-grid-item__content--center {
  padding: 0px;
}
::v-deep.van-picker__toolbar {
}
</style>